module.exports = __webpack_public_path__ + "img/slide2-2.265f509a.png";